import { mapGetters } from 'vuex'

export default {
  ...mapGetters(['professional'])
}



// WEBPACK FOOTER //
// ./src/app/professional/dashboard/professional/gadget/components/identification/resources/computed.js